const webProjects = [
	{
		projectName: `Sirav`,
		projectStack: [`React`, `SCSS`, `NodeJS`, `Express`],
		projectDescription: [
			`This is a portfolio website for a Kenyan-based music producer.`,
			`It is built using React and SCSS for the frontend and a NodeJS and Express server to handle contact form submissions and send the information to his email.`,
			`It contains a samples section where some of his music can be heard.`,
			`This section has a custom-built media player that with audio controls.`,
		],
		projectLink: `https://sirav.onrender.com`,
		projectImg: `/images/webui-projects/sirav.png`,
		projectClass: `projectItem carousel-item active`,
	},
	{
		projectName: `The Coiffeur`,
		projectStack: [`React`, `SCSS`],
		projectDescription: [
			`This is a website for a fictional hairdresser's shop.`,
			`It is a purely frontend website built using React, SCSS and Bootstrap.`,
			`It has a landing page with information about the organization and a booking page for making reservations online.`,
		],
		projectLink: `https://the-coiffeur.onrender.com`,
		projectImg: `/images/webui-projects/the-coiffeur.png`,
		projectClass: `projectItem carousel-item`,
	},
	{
		projectName: `Essence & Edges`,
		projectStack: [`NextJS`, `SCSS`, `Postgres`],
		projectDescription: [
			`A blog site for a client with both a reader accessible section and an admin section.`,
			`It is built using NextJS, SCSS for the frontend and Postgres for the database.`,
			// `It has a landing page, a portfolio page to showcase some of his art and a contact page.`,
		],
		projectLink: `https://essenceandedges.com`,
		projectImg: `/images/webui-projects/essence-and-edges.png`,
		projectClass: `projectItem carousel-item`,
	},
];

export default webProjects;
